import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-heading font-semibold text-foreground-900">
                大胸姐妹指南
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              专为大胸姐妹打造的内衣选购与穿搭知识平台，让每一位大胸姐妹都能找到真正合身、舒适、显瘦的内衣方案。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              内容分类
            </h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link to="/category/zhao-bei-ce-liang" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                  罩杯尺码测量
                </Link>
              </li>
              <li>
                <Link to="/category/jian-dai-zhi-cheng" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                  肩带支撑选择
                </Link>
              </li>
              <li>
                <Link to="/category/ri-chang-chuan-da" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                  日常穿搭技巧
                </Link>
              </li>
              <li>
                <Link to="/category/pin-pai-tui-jian" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                  品牌推荐测评
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              更多内容
            </h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link to="/category/yun-dong-nei-yi" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                  运动内衣指南
                </Link>
              </li>
              <li>
                <Link to="/category/bao-yang-hu-li" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                  保养护理知识
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              联系方式
            </h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              有任何问题或建议，欢迎通过以下方式联系我们。
            </p>
            <Link
              to="/about"
              className="inline-block mt-3 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              查看联系方式 →
            </Link>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 大胸姐妹指南. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap" rel="nofollow">
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}